import Box from 'shared_DEPRECATED/components/Box/Box';
import {
  FileDownloadButton,
  LoadingFile,
} from 'shared_DEPRECATED/components/File';
import { Attachment } from 'shared_DEPRECATED/types/Attachment';

import { ChatAttachmentUploaded } from 'features/chat/components/ChatAttachment/Uploaded';

type ChatMessageFileAttachmentProps = {
  attachmentKey?: string;
  contentType: string;
  name: string;
  url?: string;
  contentLength: number;
};

const ChatMessageFileAttachment = ({
  attachmentKey = '',
  contentType,
  name,
  url,
  contentLength,
}: ChatMessageFileAttachmentProps) => {
  return (
    <Box
      style={{
        width: ' 100%',
        display: 'grid',
        gridTemplateColumns: `repeat(1, 1fr)`,
        gap: 'var(--spacing02)',
      }}
    >
      {attachmentKey ? (
        <ChatAttachmentUploaded
          file={
            {
              key: attachmentKey,
              name,
              contentType,
              url: url || '',
              contentLength,
            } as Attachment
          }
        >
          {url && <FileDownloadButton url={url} name={name} />}
        </ChatAttachmentUploaded>
      ) : (
        <LoadingFile name={name} contentType={contentType} />
      )}
    </Box>
  );
};

export default ChatMessageFileAttachment;
